import styled, { css } from 'styled-components';

export const ModalFilterContent = styled.div`
  width: 100%;
  max-width: 40rem;
`;

export const ModalTitle = styled.h1`
  font-size: 3.4rem;
  letter-spacing: 0.17rem;
  line-height: 2.9rem;
  text-transform: uppercase;
  color: #000000;

  text-align: center;
  margin-bottom: 4.1rem;
`;

export const ModalQuestion = styled.div`
  width: 100%;
  max-width: 38.4rem;
  margin: 0 auto;

  > h2 {
    font-weight: bold;
    font-size: 2rem;
    line-height: 1.7rem;
    color: #000000;

    margin-left: 2rem;
  }

  .date_register {
    display: flex;
    width: 100%;

    margin: 0.8rem 0 2.3rem;

    > input {
      width: 100%;
      height: 4.7rem;
      border-radius: 8rem;
      border: 0.2px solid #707070;
      padding-left: 2.2rem;

      font-size: 2rem;
      line-height: 1.7rem;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      & + input {
        margin-left: 1.2rem;
      }
      /* width: 12rem; */
    }
  }

  .status {
    display: flex;

    margin: 1.3rem 4rem 3.5rem;
  }
`;

interface RadioOptionProps {
  isSelected: boolean;
}

export const RadioInput = styled.button.attrs({
  type: 'button',
})<RadioOptionProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;

  width: 100%;

  padding: 0 4rem;
  margin-bottom: 1em;

  .radio {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 2.2rem;
    height: 2.2rem;
    border: 1px solid #000;
    border-radius: 50%;

    background: transparent;

    margin-right: 0.5rem;

    transition: ${({ theme }) => theme.transition.default};

    .filled {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: inherit;

      background: ${({ isSelected }) => (isSelected ? '#000' : '#fff')};
    }
  }

  > p {
    color: #000;
    font-size: 2rem;
    font-weight: bold;
    transition: ${({ theme }) => theme.transition.default};
  }

  &:active {
    opacity: 0.5;
  }

  &:hover {
    .radio {
      border-color: #000;
    }

    > p {
      color: #000;
    }
  }
`;

export const RadioContainer = styled.div`
  margin-bottom: 4rem;
`;

export const NewButtonContainer = styled.div`
  margin-bottom: 3.2rem;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
  }
`;

type ButtonWrapperProps = {
  secondary?: boolean;
  filter?: boolean;
};

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  @media (max-width: 768px) {
    justify-content: space-evenly;

    ${(props) =>
      props.filter &&
      css`
        justify-content: flex-end;
      `}
  }

  ${(props) =>
    props.secondary &&
    css`
      justify-content: flex-end;
    `}
`;

export const NewButton = styled.button`
  color: #000;
  width: 328px;
  height: 50px;
  background: transparent linear-gradient(90deg, #ffd503 0%, #ffdf22 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 50px;
  opacity: 1;
  font-size: 19px;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100%;
    height: 50px;
  }

  &:hover {
    filter: brightness(0.9);
  }
`;

export const NewButtonLabel = styled.div`
  text-transform: uppercase;
  font-weight: bold;
  padding-left: 5px;
`;

type FilterLabelProps = {
  filter?: boolean;
};

export const FilterLabel = styled.p<FilterLabelProps>`
  font-size: 1.8rem;
  color: #fff;
  margin-right: 0.92rem;

  @media (max-width: 768px) {
    display: none;

    ${(props) =>
      props.filter &&
      css`
        display: flex;
      `}
  }
`;

export const FilterOptions = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;

  font-size: 0;
  background: transparent;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const Options = styled.div`
  position: relative;
  cursor: pointer;

  &:hover {
    > div {
      opacity: 1;
      pointer-events: visible;
      width: 11rem;
    }
  }
  > svg {
    &:hover {
      opacity: 0.5;
    }
  }

  > div {
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 0;
    position: absolute;
    top: 2rem;
    left: -9.7rem;
    overflow: hidden;

    background: #ffffff;

    box-shadow: 0px 0px 4px #40404030;
    border-radius: 2px;

    opacity: 0;

    transition: 300ms ease-in-out;

    .divider {
      height: 1px;
      background: #cbcbcb;
      margin: 0 0.3rem;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      background: #ffffff;
      height: 4rem;
      border-radius: 0;

      color: #0f0f0f;
      font-size: 1.4rem;
      font-family: ${({ theme }) => theme.fontFamily.Nunito};
      font-weight: 600;
      line-height: 1.9rem;

      &:hover {
        background: #40404030;
      }
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;

  > h1 {
    color: #ffdf22;
  }
`;

export const CardContainer = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 4.2rem 6.2rem;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;

    gap: 2rem;
  }
`;

export const NoDataFound = styled.div`
  width: 100%;
  text-align: center;

  margin-top: 10%;

  p {
    font-size: 2rem;
    color: white;
  }
`;
